<template>
  <div
    data-name="final-score-wrapper"
    :class="$style.wrapper"
  >
    <div :class="$style['header-container']">
      <div :class="$style.header">
        Final Score
      </div>
      <div :class="$style['total-score-wrapper']">
        <div :class="$style['total-score-container']">
          {{ totalScore }}
        </div>
      </div>
    </div>
    <ul
      :class="$style['rooms-list-container']"
    >
      <li
        :class="$style['rooms-list-element-container']"
        v-for="room in roomsData"
      >
        <div :class="$style['rooms-list-element-title']">
          {{ room.name }}
        </div>
        <div :class="$style['rooms-list-element-score']">
          {{ room.score }} / {{ room.totalQuestions }}
        </div>
      </li>
    </ul>

  </div>
</template>

<script>
export default {
  name: 'final-score',
  components: {},
  props: ['roomsData', 'totalScore'],
  data() {
    return {};
  },
  computed: {

  },
  mounted() {
    // console.log(this);
  }
};
</script>

<style lang='scss' module>
@import '../assets/css/globals.scss';

* {
  // outline: 1px solid red;
}

.wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  color: white;

  // background-color: rgba(70, 82, 52, 1.00);

  width: 100%;
}

.total-score-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 16px;

  @include large {
    margin-left: 32px;
  }
}

.total-score-container {
  display: flex;
  justify-content: center;
  align-items: center;

  width: 80px;
  height: 80px;

  background-color: rgba($black, 0.1);

  // font-family: sans-serif;
  font-size: 20px;
  // color: white;

  border-radius: 50%;

  @include large {
    height: 120px;
    width: 120px;
    font-size: 40px;
  }
}

.header-container {
  display: flex;
  justify-content: center;
  align-items: center;

  // padding: 30px;
  padding-top: 15px;

  font-size: 20px;
  font-weight: 600;

  @include large {
    font-size: 40px;
  }
}

ul {
  padding: 0;
  list-style: none;
}

.rooms-list-container {
  width: 100%;
}

.rooms-list-element-container {
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;

  padding-top: 20px;
  padding-right: 10px;
  padding-bottom: 20px;
  padding-left: 10px;

  border-top: 1px solid rgba(0, 0, 0, 0.2);

  box-sizing: border-box;
}

.rooms-list-element-container:last-of-type {
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}

.rooms-list-element-title {
}

.rooms-list-element-score {
  color: rgba(190, 191, 43, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/FinalScore.vue